module.exports = __webpack_public_path__ + "img/img0302.f0dddccd.png";